function productHeaderDirective() {
	return {
		scope : {
			idProduct: '='
		},
		restrict : 'E',
		replace : true,
		templateUrl : function(elem, attr) {
			return 'views/directives/productHeaderDirective.html';
		},
		controller : [ '$scope', '$window', 'alertService', 'productService', function($scope, $window, alertService, productService) {
			$scope.product = null;

			$scope.loadProduct = function(idProduct) {
				productService.loadProduct(idProduct).then(function(response) {
					$scope.product = response.getData();
                }, function(response) {
                	//on error
                });
			};
			
			$scope.loadProduct($scope.idProduct);
			

		} ],
		link : function(scope, elem, attr) {
			
		}
	};
};

module.directive('productHeader', [ productHeaderDirective ]);
